import { Alert } from "@mui/material";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const AlertMessage = ({ message, severity }) => {
    let result = "";

    switch (severity) {
        case "success":
            result = (
                <Alert
                    data-cy="success-alert"
                    severity="success"
                    icon={<CheckCircleIcon fontSize="medium" />}
                >
                    {message}
                </Alert>
            );
            break;

        case "warning":
            result = (
                <Alert
                    data-cy="warning-alert"
                    severity="warning"
                    icon={<WarningAmberIcon fontSize="medium" />}
                >
                    {message}
                </Alert>
            );
            break;

        case "error":
            result = (
                <Alert
                    data-cy="error-alert"
                    severity="error"
                    icon={<WarningAmberIcon fontSize="medium" />}
                >
                    {message}
                </Alert>
            );
            break;

        case "info":
            result = (
                <Alert
                    data-cy="infor-alert"
                    severity="info"
                    icon={<InfoOutlinedIcon fontSize="medium" />}
                >
                    {message}
                </Alert>
            );
            break;

        default:
            break;
    }

    return result;
};

export default AlertMessage;
